import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";
import s from "~/components/Table/TableRow/EditorIndicatorsTableRow/TableRow.less";

const renderCellWithPeriod = (
  value: any,
  record: any,
  optionName: string,
  optionChildren: string[]
) => {
  const hasPeriod =
    optionChildren.length > 0 && optionChildren.includes(optionName);
  const periodValue = hasPeriod ? record[optionName + "Period"] : null;

  return (
    <div>
      <span className={s.cont}>{value}</span>
      {periodValue && <div className={s.cont_under}>{periodValue}</div>}
    </div>
  );
};

export const getEditorGRIndicatorsColumns = (
  t: TFunction,
  options: string[],
  optionChildren: string[]
): ColumnsType<any> =>
  options.map((option) => {
    const baseColumn = {
      title: t(`editorGR.${option}`),
      dataIndex: option,
      key: option,
    };

    // Колонки с Period (quarter1, quarter2, и т.д.)
    if (optionChildren.includes(option)) {
      return {
        ...baseColumn,
        render: (value: any, record: any) =>
          renderCellWithPeriod(value, record, option, optionChildren),
      };
    }

    // Обычные колонки
    return {
      ...baseColumn,
      render: (value: any) => <span className={s.cont}>{value}</span>,
    };
  });
